var map = {
	"./Icon awesome-calculator.pngZone.Identifier": "eb35",
	"./afk-arena.png": "d4aa",
	"./animal-crossing.png": "f3b1",
	"./calculator-icon.png": "336f",
	"./candy-crush-saga.png": "1508",
	"./cod-black-ops-iiii.png": "8354",
	"./cod-cold-war.png": "0e9e",
	"./cod-modern-warfare.png": "082d",
	"./cyberpunk-2077.png": "d3db",
	"./doom-eternal.png": "1fc3",
	"./dungeon-fighter-online.png": "d40d",
	"./fifa-20.png": "0fa1",
	"./fifa-21.png": "d128",
	"./fortnite.png": "8d56",
	"./free-fire-1.png": "a366",
	"./free-fire.png": "e5b5",
	"./gta-v.png": "0af3",
	"./honor-of-kings.png": "41ab",
	"./league-of-legends.png": "4e4e",
	"./nba-2k20.png": "ee16",
	"./nba-2k21.png": "37b7",
	"./peacekeeper-elite.png": "113a",
	"./pokemon-go.png": "5421",
	"./roblox.png": "5d25",
	"./sims-4.png": "da42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1d0";